import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';

import { InheritableType } from '../is-inheritable/is-inheritable.model';


@Directive({
    selector: '[easEditorBookingItemInheritableTypeHeader]',
    standalone: false
})
export class EditorBookingItemInheritableTypeHeaderDirective implements OnChanges, OnInit {
  @Input() inheritableType: InheritableType;

  private cssClasses: string[];

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.cssClasses = [];
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.inheritableType) {
        this.cssClasses.forEach(headerClass =>
          this.renderer.removeClass(this.el.nativeElement, headerClass)
        );

        this.cssClasses = this.getHeaderClasses();

        this.cssClasses.forEach(headerClass =>
          this.renderer.addClass(this.el.nativeElement, headerClass)
        );
    }
  }

  private getHeaderClasses(): string[] {
    switch (this.inheritableType) {
      case 'empty':
        return ['option_header--empty'];
      case 'set':
      case 'inherited':
      case 'inherited-overridden':
      case 'overridden':
        return ['option_header--set'];
    }
  }
}
